/* eslint-disable */
import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'

const PrivateRoutes = () => {
    const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'))
    const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
    const AccountPage = lazy(() => import('../../app/modules/accounts/AccountPage'))
    const PersonKycPage = lazy(() => import('../modules/kyc/PersonKycPage'))
    const CompanyKycPage = lazy(() => import('../modules/kyc/company/CompanyKycPage'))
    const PersonOnboardingPage = lazy(() => import('../../app/modules/onboarding/person/PersonOnboardingPage'))
    const CompanyOnboardingPage = lazy(() => import('../../app/modules/onboarding/company/CompanyOnboardingPage'))
    const PersonAmendmentsPage = lazy(() => import('../../app/modules/amendments/person/PersonAmendmentsPage'))
    const BulkPage = lazy(() => import('../../app/modules/bulk/BulkPage'))


    return (
        <Routes>
            <Route element={<MasterLayout/>}>
                <Route path='auth/*' element={<Navigate to='/customers/person/verification'/>}/>

                {/* Pages */}
                <Route path='dashboard' element={<DashboardWrapper/>}/>
                <Route path='builder' element={<BuilderPageWrapper/>}/>
                <Route path='menu-test' element={<MenuTestPage/>}/>
                {/* Lazy Modules */}
                <Route
                    path='customers/person/*'
                    element={
                        <SuspensedView>
                            <PersonKycPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='customers/company/*'
                    element={
                        <SuspensedView>
                            <CompanyKycPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='onboarding/person/*'
                    element={
                        <SuspensedView>
                            <PersonOnboardingPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='onboarding/company/*'
                    element={
                        <SuspensedView>
                            <CompanyOnboardingPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='amendments/person/*'
                    element={
                        <SuspensedView>
                            <PersonAmendmentsPage/>
                        </SuspensedView>
                    }
                />
                <Route
                    path='account/*'
                    element={
                        <SuspensedView>
                        <AccountPage />
                        </SuspensedView>
                    }
                />
                <Route
                    path='bulk/*'
                    element={
                        <SuspensedView>
                        <BulkPage />
                        </SuspensedView>
                    }
                />

                {/* Page Not Found */}
                <Route path='*' element={<Navigate to='/error/404'/>}/>
            </Route>
        </Routes>
    )
}

const SuspensedView: FC = ({children}) => {
    const baseColor = getCSSVariableValue('--bs-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress/>}>{children}</Suspense>
}

export {PrivateRoutes}
